import { Navigate, useParams } from 'react-router-dom';
export default function ProspectingDetailPage() { const { id } = useParams(); return <Navigate replace to={`/partenaires/${id}`} />; }
